// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"826":"user-rights-roles","893":"login-home-welcome"}[chunkId] || chunkId) + "." + {"160":"7f12a5b0","826":"ea4a5616","893":"c3b1fa00"}[chunkId] + ".js";
};